import React from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { Input, Radio, Textarea } from "../../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../../ui/buttons/Button";

export default function ActualizarAumentosSueldos({ show, setShow, setTabla }) {
  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Actualizar Aumentos de Sueldos</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-3 m-0  mb-2 p-0">
          <Input label = 'Cod. Del Aumento:' />
        </div>
        <div className="col-4 m-0 mb-2 ml-auto p-0">
          <Input label = 'Fecha del aumento' type = 'date' />
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-2">
          <Input label = 'Numero de Gaceta' /> 
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Textarea label = 'Descripción:' style={{ height: 70 }} />
        </div>
        <div className="col-12 m-0 p-0 d-flex gap-2">
          <div className="col-auto m-0 p-0">
            <Radio label = 'Por Porcentaje' name = 'filtro' id = 'porPorcentaje'/>
          </div>
          <div className="col-auto m-0 p-0">
            <Radio label = 'Por Monto' name = 'filtro' id = 'porMonto'/>
          </div>
        </div>
        <div className="col-3 m-0 ml-auto p-0">
          <Input label = 'Porcentaje:' />
        </div>
        <div className="col-4 m-0 p-0 pl-2">
          <Input label = 'Fecha de Aplicación:' />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton>Aceptar</SuccessButton>
        <DangerButton>Cancelar</DangerButton>
      </Modal.Footer>
    </Modal>
  );
}
